import React from "react";
import { Button, maxLength, required, TextInput, useNotify, useRefresh } from "react-admin";
import UndoIcon from "@mui/icons-material/Undo";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { scholarshipRequests } from "api/scholarshipApi";

const ReturnForCorrectionDialog = ({ id }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    await dataProvider.customRequest(
      scholarshipRequests.returnScholarshipForCorrection(id),
      { comment: data.comment },
      "PUT",
    );
    refresh();
    notify("Кандидатурата е върната за корекция!", { type: "success" });
  };

  return (
    <FormModal
      titleContent="Връщане на кандидатура за корекция"
      saveTitle="Върни"
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          startIcon={<UndoIcon />}
          size="small"
          label="Върни за корекция"
          color="warning"
          variant="contained"
        />
      }
    >
      <TextInput
        source="comment"
        label="Причина за връщане"
        validate={[required(), maxLength(300)]}
        multiline
        minRows={3}
        fullWidth
      />
    </FormModal>
  );
};

export default ReturnForCorrectionDialog;
